module.exports = __webpack_public_path__ + "static/media/img2-3.2d245282.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/nutricheck_foliar/CA/img2-3.png
// module id = 1465
// module chunks = 3